import React from 'react';
// Icons
import { FaStar } from 'react-icons/fa';

function FiveStarComponent() {
  return (
    <section className='absolute top-16 left-1/2 transform -translate-x-1/2 grid md:-translate-x-0 md:top-[95%] md:left-8'>
      <div className='grid grid-flow-col w-fit gap-2 text-colour3 text-xl'>
        {[1, 2, 3, 4, 5].map((star, index) => {
          return <FaStar key={index} />;
        })}
      </div>
    </section>
  );
}

export default FiveStarComponent;
